import DomaineIndictor from "../../pages/libraries/components/DomainManagement/DomaineIndicator";
import DateModificationTopology from "../../pages/treatments/DataModificationTopology";
import DataCreationTopology from "../../pages/treatments/DateCreationTopology";

interface IIndicators {
  element: any;
  type: string;
}





const Indicators = ({ element, type }: IIndicators) => {
  switch (type) {
    case "domaine":
      return <DomaineIndictor domaine={element} />;
    case "topologiesCreation":
      return <DataCreationTopology topology={element}/>
    case "topologiesModification":
      return <DateModificationTopology topology={element}/>
    default:
      return <></>;
  }
};

export default Indicators;
